import { itiMessageService, ItiString, itiHttpService } from '@/iti-core-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, max, min } from 'vee-validate/dist/rules';
import { API } from '@/shared/api';
import { localize } from 'vee-validate';
import { VAutocomplete, VTextField, VSelect } from 'vuetify/lib'
import router from '@/router';
import { User } from '@/shared/dtos/user';
import '@/../public/assets/css/chat.css';

extend('max', max);
extend('min', min);


localize({
    va: {
      messages: {
        required: 'Aquest camp no pot estar buit',
        max: 'Aquest camp deu de tindre menys de {length} caràcters'
      }
    }
  });

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
        VAutocomplete,
        VTextField,
        VSelect
    },
})
export default class ProductoFormulario extends Vue {
    

    public roomName: string = '';
    public selectedUserId: number = 0;
    public selectedUsers: number[] = [];

    public users: User[] = [];
    $refs!: {
        observer: any
      }
    public cancelar(){
        this.returnToHome();
    }
    public returnToHome(){
        router.push({ name: 'Home'});
    }
    public addUserToRoom(){

    }
    public created(){
      const urlIdsRequest = ItiString.Format('{0}',API.chat+'/users');
        itiHttpService.get(urlIdsRequest).catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
        .then((value) =>{
          this.users = value;
        });
    }

    public async onSubmit() {
        const result = this.$refs.observer.validate();
        if(result){
           await this.submitRoom();
        }
    }

    public async submitRoom(){
        //First we create the room
        var room: any = {
          id: 0,
          roomName: this.roomName,
          collaborativeAreaId: 0,
          state: 0
        }
        const url = ItiString.Format('{0}', API.chatRoomCrud);

        var newRoomId = 0;
        await itiHttpService.post(url, JSON.stringify(room))
            .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
            .then((value) =>{
              newRoomId = value.id;
              });

        //Then we add the users
        const userInRoomUrl = ItiString.Format('{0}', API.chatUserInRoomCrud)
        this.selectedUsers.forEach(async userId => {
          var userInRoom: any = {
            id: 0,
            roomId: newRoomId,
            userId: userId
          }
          await itiHttpService.post(userInRoomUrl, JSON.stringify(userInRoom))
          .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
          .then((value) => {})
        })

        itiMessageService.toast("Sala creada correctamente");
        this.returnToHome();
        
        /*const url = ItiString.Format('{0}/{1}', API.notifications, this.idDestinoAutocomplete);
        await itiHttpService.post(url, JSON.stringify(this.texto))
            .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
            .then((value) =>{
               itiMessageService.toast("Mensaje mandado correctamente");
               this.returnToHome();
            } );
        */
    }
    
}
